<template>
  <div
    :id="`${row ? 'custom_table' : source}_audio_player`"
    class="audio_player"
  >
    <audio
      controls
      :class="[
        'dark_audio',
        {
          dark_audio_invert: effectiveTheme === themeTypes.DARK,
        },
      ]"
    >
      <source :src="row?.source || audioUrl" :type="type" />
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<script setup>
import { computed } from "vue";
import store from "@/src/store/index.js";
import { themeTypes } from "@/src/constants/themeConstants.js";

const props = defineProps({
  source: { type: String, required: true },
  type: { type: String, required: true },
  audioUrl: { type: String, required: true },
  height: { type: Number, default: 26 },
  row: { type: Object, required: false },
});

const effectiveTheme = computed(() => store.getters["theme/getEffectiveTheme"]);
</script>

<style scoped>
.audio_player {
  width: 100%;
  border-radius: 8px;
  height: v-bind(height + "px");
  display: flex;
  align-items: center;
}

.audio_player audio {
  width: 100%;
  height: 100%;
}

.dark_audio::-webkit-media-controls-panel {
  background-color: var(--audio-player-default-color);
  border-color: var(--audio-player-default-color);
}

.dark_audio::-webkit-media-controls-current-time-display,
.dark_audio::-webkit-media-controls-time-remaining-display {
  color: var(--foreground-rgb);
  text-shadow: none;
}

.dark_audio_invert::-webkit-media-controls-play-button,
.dark_audio_invert::-webkit-media-controls-mute-button {
  filter: invert(1);
}

.dark_audio::-webkit-media-controls-timeline {
  background-color: transparent;
}

.dark_audio::-webkit-media-controls-volume-slider {
  background-color: transparent;
}

.dark_audio::-moz-range-thumb {
  background-color: var(--foreground-rgb);
}

.dark_audio::-webkit-media-controls-enclosure {
  background-color: transparent;
}
</style>
